export const mascaraCAR = cars => {
    return cars
        .split(',')
        .map(car => {
            const carLimpo = car.replace(/[^A-Za-z0-9]/g, '');
            const regex =
                /^([A-Za-z]{2})([0-9]{7})([A-Za-z0-9]{4})([A-Za-z0-9]{4})([A-Za-z0-9]{4})([A-Za-z0-9]{4})([A-Za-z0-9]{4})([A-Za-z0-9]{4})([A-Za-z0-9]{4})([A-Za-z0-9]{4})$/;
            const formatado = carLimpo.replace(
                regex,
                '$1-$2-$3.$4.$5.$6.$7.$8.$9.$10'
            );

            return formatado;
        })
        .join('<br>');
};

export const mascaraCPF = cpf =>
    cpf
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

export const mascaraCNPJ = cnpj =>
    cnpj
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
